import { useEffect, useState } from 'react'
import useJsonStorage from './useJsonStorage'

export default function useInviteStorage(id, token) {
  const [getInvite, setInviteStorage, clearInviteStorage] =
    useJsonStorage('invite')
  const [invite, setInvite] = useState(() => getInvite())

  useEffect(() => {
    if (id != null && token != null) {
      setInviteStorage({ id, token })
      setInvite({ id, token })
    }
  }, [id, token])

  const clearInvite = () => {
    clearInviteStorage()
    setInvite(null)
  }

  return {
    invite,
    setInvite,
    clearInvite,
    invitePath:
      invite != null ? `/invite?id=${invite.id}&invite=${invite.token}` : null,
  }
}
